// @flow
import Terms from './Terms'
export default Terms



// WEBPACK FOOTER //
// ./src/containers/SecureRoom/components/Terms/index.js